import { MultipleEntitySelector } from './MultipleEntitySelector'
import { SingleEntitySelector } from './SingleEntitySelector'

type EntitySelectorWithMultiple = typeof SingleEntitySelector & {
  Multiple: typeof MultipleEntitySelector
}

// eslint-disable-next-line no-type-assertion/no-type-assertion
const EntitySelector = SingleEntitySelector as EntitySelectorWithMultiple
EntitySelector.Multiple = MultipleEntitySelector

export { EntitySelector }
